import React from 'react';

type TabTitleProps = {
  label: string;
  badge?: string;
  active: boolean;
  systemTab?: boolean;
};

export const TabTitle = ({ label, badge, active, systemTab }: TabTitleProps) => {
  return (
    <span
      className={systemTab ? 'tab-title-system' : ''}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {!systemTab && <span className={`tab-badge ${active ? 'active' : 'inactive'}`}>{badge}</span>}
      <span
        className={`tab-title-label  ${systemTab ? 'tab-title-label-system' : ''} ${
          active ? 'active' : 'inactive'
        }`}
      >
        {label}
      </span>
    </span>
  );
};
